import React, { useEffect, useState } from 'react';
import "react-toggle/style.css"
import { CircularProgress, Grid, styled, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export function CustomTable({ refresh, setRefresh, columns, dataEndpoint, pageSize, title, actions, onRowClick }) {
    const [data, setData] = useState<any[]>([]);
    const [query, setQuery] = useState<any>({
        page: 1
    });
    const [numberOfItems, setNumberOfItems] = useState<number>(-1);
    const [pageNumber, setPageNumber] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [hasFullData, setHasFullData] = useState<boolean>(false);
    const [fullData, setFullData] = useState<any[]>([]);
    const [numberPerPage, setNumberPerPage] = useState<number>(0);

    useEffect(() => {
        if (loading) return
        if(refresh && dataEndpoint) {
            getData();
        }
    }, [refresh])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (loading) return
        getData()
    }, [query])// eslint-disable-line react-hooks/exhaustive-deps

    const getData = () => {
        setLoading(true)
        dataEndpoint(query)
            .then(x =>{
                setLoading(false)
                setRefresh(false)
                if(x.data.length > x.numberPerPage){
                    setData(x.data.slice(0, x.numberPerPage))
                    setFullData(x.data)
                    setHasFullData(true)
                    setNumberPerPage(x.numberPerPage)
                } else {
                    setData(x.data)
                }
                setNumberOfItems(x.totalCount)
            }).catch(x => {
                setQuery({page:1})
                setRefresh(true)
                alert("Failed to get page.")
            })
    }

    const changePage = (e, page) => {
        if(hasFullData){
            setData(fullData.slice(page*numberPerPage, (page+1)*numberPerPage));
            setPageNumber(page)
        } else {
            setPageNumber(page);
            setQuery({
                page: page+1
            });
        }
    }

    const StyledTableRow = styled(TableRow) ({
        '&:nth-of-type(odd)': {
          backgroundColor: "white",
        },
        '&:nth-of-type(even)': {
          backgroundColor: "#F9F9F9",
        },
      });

    const handleTableRowKeyDown = (e, row) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onRowClick && onRowClick(row);
        }
    };

    return (
        <>
        <h3 style={{float:"left"}}>{title}</h3>
        {actions?.some(x => x.isFreeAction) &&
            actions.filter(x => x.isFreeAction).map(x => (
                <Tooltip title={x.tooltip} placement="bottom" style={{ float:"right", marginTop:"30px", marginRight:"30px", cursor:"pointer" }}>
                    <span onClick={x.onClick} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); x.onClick(); } }}>
                        {x.icon()}
                    </span>
                </Tooltip>
            ))
        }
        <Grid container style={{ overflowX: "auto" }}>
            <Table aria-label={typeof title === 'string' ? (title || "Data table") : "Data table"}>
                <TableHead>
                    <TableRow>
                        {columns.map((x, colIndex) => (
                            <>
                                {!x.hidden &&
                                    <TableCell key={x} variant="head" scope="col" id={`col-${x.field || colIndex}`} style={{textAlign: "center"}}>
                                        {x.title}
                                        {x.tooltip ? (<Tooltip title={x.tooltip} placement="top"><InfoOutlinedIcon fontSize='small' /></Tooltip>) : ""}
                                    </TableCell>
                                }
                            </>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading &&
                        <div className='loading-container'><CircularProgress aria-label="Loading data" className='center-spinner' /></div>
                    }
                    {!loading && data?.length === 0 &&
                        <TableRow>
                            <TableCell colSpan={columns.filter(x => !x.hidden).length} style={{textAlign: "center"}}><i>No items to show</i></TableCell>
                        </TableRow>
                    }
                    {data?.map((row) => (
                        <StyledTableRow key={row.name} onClick={onRowClick ? () => onRowClick(row) : undefined} onKeyDown={onRowClick ? (e) => handleTableRowKeyDown(e, row) : undefined} tabIndex={onRowClick ? 0 : undefined} role={onRowClick ? "button" : undefined} aria-label={onRowClick ? "Select row" : undefined} style={{ cursor: onRowClick ? "pointer" : "auto" }}>
                            {columns.map((x, colIndex) => (
                                <>
                                    {!x.hidden &&
                                        <TableCell key={x} headers={`col-${x.field || colIndex}`} style={{textAlign: "center"}}>{x?.render ? x.render(row) : row[x.field]}</TableCell>
                                    }
                                </>
                            ))}
                        </StyledTableRow>
                    ))}
                </TableBody>
                <TableFooter>
                    {numberOfItems > pageSize &&
                        <TablePagination SelectProps={{disabled: loading}}
                            backIconButtonProps={
                                loading
                                ? {
                                    disabled: loading
                                }
                                : undefined
                            }
                            nextIconButtonProps={
                                loading
                                ? {
                                    disabled: loading
                                }
                                : undefined
                            }
                            count={numberOfItems} onPageChange={changePage} page={pageNumber} rowsPerPage={pageSize} rowsPerPageOptions={[]} showFirstButton={true} showLastButton={true}></TablePagination>
                        }
                </TableFooter>
            </Table>
        </Grid>
    </>)

}
